export function toggleLoading(on, content) {
	const elem = document.getElementById("loading");

	if (typeof elem !== "undefined" && elem !== null) {

		if (typeof on === 'undefined' || on === true) {
			elem.classList.add('visible');

			if (typeof content !== 'undefined') {
				elem.querySelector('.content').innerHTML = content;
			}
		}
		else {
			// Clear content
			elem.querySelector('.content').innerHTML = '';
			elem.classList.remove('visible');
		}
	}
}

export function changeLoadingText(text) {
	const elem = document.getElementById("loading");
	elem.querySelector('.content').innerHTML = text;
}

// Validoidaan lomakkeen syöttökentät hyödyntäen HTML5 API
export function validate(formEl) {
	const formLength = formEl.length;
	// Tarkistaa, että validoidaanko lomake ilman lähetystä
	if (formEl.checkValidity() === false) {
		// Käydään läpi kaikki lomakkeen elementit
		for (let i = 0; i < formLength; i++) {
			const elem = formEl[ i ];
			// Poistetaan olemassaoleva virheluokka
			elem.classList.remove("error");
			elem.classList.remove("is-invalid");
			const errorLabel = elem.parentNode.querySelector(".invalid-feedback");

			if (errorLabel && elem.nodeName.toLowerCase() !== "button") {
				if (!elem.validity.valid) {
					// Napataan attribuutista "validationmessage" virheilmoitus ja esitetään se
					errorLabel.textContent = elem.getAttribute("validationmessage");
					// Lisätään virheluokka
					elem.classList.add("error");
					elem.classList.add("is-invalid");
				}
				else {
					// Ei virhettä
					errorLabel.textContent = "";
				}
			}
		}

		return false;
	}
	else {
		for (let i = 0; i < formLength; i++) {
			const elem = formEl[ i ];
			const errorLabel = elem.parentNode.querySelector(".invalid-feedback");
			elem.classList.remove("is-invalid");
			if (errorLabel && elem.nodeName.toLowerCase() !== "button") {
				errorLabel.textContent = "";
			}
		}

		return true;
	}
}

/**
 * List id's of input fields that have failed form validation.
 * Inputs that have failed form validation have classes 'error' and/or 'is-invalid'.
 *
 * @param {*} formEl form elements to check
 * @returns array of input id's
 */
export function listInvalidFields(formEl) {
	let invalidFields = [];

	// add invalid fields to the list
	for (const elem of formEl) {
		if (elem.nodeName.toLowerCase() !== "button" && (elem.classList.contains('error') || elem.classList.contains('is-invalid'))) {
			invalidFields.push(elem.id);
		}
	}

	return invalidFields;
}
